import GOTUtil from './GOTUtil';
import GOT from './GOT';
import Warning from './Warn';
import AuthorityUtil from './AuthorityUtil';
import StringUtil from './StringUtil';
import FormResourceUtil from './FormResourceUtil';
import CommandResolver from './CommandResolver';
import CommandHelper from '../remote/CommandHelper';
import ServiceHelper from '../remote/ServiceHelper';
import FormLoadHelper from './FormLoadHelper';

export default class MainFormFactory
{
	static mapMainForm = {};	
	static hasMainForm(entityId, innerId, componentItemName)
	{
		if(window.parent.window.formOSopenAllUniversal || window.isDataSetView || window.parent.window.isDataSetView){
			return false;
		}
		var key = MainFormFactory.getKey(entityId, innerId, componentItemName);
		if(!key)
			return false;
		var result;
		if(MainFormFactory.mapMainForm.hasOwnProperty(key))
		{
			result = MainFormFactory.mapMainForm[key];
		}
		else
		{
			result = MainFormFactory.getMainForm(entityId, innerId, componentItemName);
			if(result != null)
				MainFormFactory.mapMainForm[key] = result;
		}
		
		if(result==null)
		{
			return false;
		}
		else
		{
			return true;
		}
	}

	static getFinalMainTableAndMainFormProFromDataType(dataType,result)
	{
		var dataTypeRelation = dataType.DataTypeRelation;
		if(dataTypeRelation)
		{
			var mainTablePro = GOTUtil.getProperty(dataTypeRelation,"Table");
			var mainFormPro = GOTUtil.getProperty(dataTypeRelation,"RefMenuItem")
							  ||GOTUtil.getProperty(dataTypeRelation,"MainForm");
			result.dataTypeRelation = dataTypeRelation;
			if(mainTablePro.hasOwnProperty("refentityid") && !result.hasOwnProperty("MainTablePro"))
			{
				result.MainTablePro = mainTablePro;
			}
			
			if(mainFormPro.hasOwnProperty("refentityid") && !result.hasOwnProperty("MainFormPro"))
			{
				result.MainFormPro = mainFormPro;	
			}
		}
		
		if(!result.hasOwnProperty("MainTablePro") || !result.hasOwnProperty("MainFormPro"))
		{
			var extendsPro = GOTUtil.getProperty(dataType,"Extends");
			if(extendsPro.hasOwnProperty("refentityid"))
			{
				dataType = GOT.getDataType(extendsPro.refentityid);
				result = MainFormFactory.getFinalMainTableAndMainFormProFromDataType(dataType,result);
			}
		}
		
		return result;
	}

	static getMainForm(entityId, innerId, componentItemName)
	{
		var dataType = GOTUtil.getDataType2(entityId, innerId);
		if(dataType==null)
		{
			return null;
		}
		
		if(dataType.type=="Component")
		{
			if(componentItemName)
			{
				var componentItemList = dataType.DataTypeArrayItems;
				for(let i = 0;i<componentItemList.length;i++)
				{
					let componentItem = componentItemList[i];
					if(componentItem.name==componentItemName)
					{
						dataType = GOT.getDataType(GOTUtil.getProperty(componentItem, "RefDataType").refentityid);
						break;
					}
				}
			}
		}
		
		if(dataType.type!="String")
		{
			return null;
		}	
		
		var mainFormPro = null;var mainTablePro = null;var resultObject = {};
		resultObject = MainFormFactory.getFinalMainTableAndMainFormProFromDataType(dataType,resultObject);
		
		if(!resultObject.MainTablePro || !resultObject.MainFormPro)
		{
			return null; 
		}
		var dataTypeRelation = resultObject.dataTypeRelation;
		mainTablePro = resultObject.MainTablePro;
		var mainTable = GOT.getTable(mainTablePro.refentityid);
		mainFormPro = resultObject.MainFormPro;	
		
		var menuItem = GOT.getMenuItem(mainFormPro.refentityid);
		var proRefObject = GOTUtil.getProperty(menuItem, "RefObject") || GOTUtil.getProperty(menuItem,"Source");
		if(!proRefObject.hasOwnProperty("refentityid"))
		{
			return null;
		}
		
		var mainFormName = proRefObject.Value || proRefObject.V;
		
		var obj = {};
		obj["menuItemId"] = mainFormPro.refentityid;
		obj["mainFormName"] = mainFormName;
		obj["dataTypeRelation"] = dataTypeRelation;
		obj["mainTable"] = mainTable;
		obj["mainFormId"] = proRefObject.refentityid;
		return obj;
		
	}

	static getKey(entityId, innerId, componentItemName)
	{
		return entityId + "." + innerId + "." + componentItemName;
	}

	static callMainForm(options)
	{
		//entityId, innerId,componentItemName,value,fm,groupAlias,caller
		var key = MainFormFactory.getKey(options.entityId, options.innerId, options.componentItemName);
		
		if(MainFormFactory.mapMainForm.hasOwnProperty(key) && MainFormFactory.mapMainForm[key] != null)
		{
			var result = MainFormFactory.mapMainForm[key];
			var menuItemId = result["menuItemId"];
			var authorityObject = AuthorityUtil.getAuthorityMenuItem(menuItemId);
			//TODO BEGIN mainform
			
			let mainFormWhereValues = MainFormFactory.getMainTableWhereValues2(
				{
					entityId:options.entityId, innerId:options.innerId, 
					componentItemName:options.componentItemName, 
					value:options.value, result:result, record:options.record,
					filterValue:options.filterValue
				}
			);

			let options2 = {
				menuItemId:menuItemId,fm:options.fm,mainTableWhereValues:mainFormWhereValues,authorityArg:authorityObject,
				addJoin:false,entityId:options.entityId,checkHas:false,
				dataField:options.dataField,groupAlias:options.groupAlias,editorName:options.editorName,paramString:options.paramString
			};
			//TODO END
			if(!options.fm)
			{
				FormLoadHelper.openMenuItemByAuthority(options2);	
			}
			else
			{
				MainFormFactory.callRemoteMainForm(options2);
			}
			
			return true;
		}
		else
		{
			let options2 = {
				menuItemId:null,fm:options.fm,mainTableWhereValues:null,authorityArg:null,
				addJoin:false,entityId:options.entityId,checkHas:false,
				dataField:options.dataField,editorName:options.editorName,groupAlias:options.groupAlias,paramString:options.paramString
			};
			MainFormFactory.callRemoteMainForm(options2);
		}
	}

	static callRemoteMainForm(options)
	{
		//在Dialog或者Report上进入主表 openFormArg,authorityObject,caller,groupAlias,fm
		if(!options.fm)
		{
			if(options.authorityArg["query"] == false)
			{
				if(window.parent.userInfos && window.parent.userInfos.userGroups && window.parent.userInfos.userGroups.length>0){
					Warning.show({text:"您没有权限进去该画面"});
				}else{
					Warning.show({text:"您所在的用户组没有权限"});
				}
			}
			else
			{
				FormLoadHelper.openMenuItem(options);
			}
			return;
		}
		var methodName;
		//if(caller.dataField!=null)
		if(options.groupAlias && options.dataField)
		{
			var i = options.dataField.indexOf(".");
			methodName = StringUtil.convertToEachFirstUpperCase(options.dataField.substring(i+1));
			methodName = "mainForm_" + StringUtil.replaceAll(methodName, ".", "_");
			methodName = options.groupAlias + "." + methodName;
		}
		else
		{
			methodName = "mainForm_" + options.editorName;
		}
		
		
		let mi = FormResourceUtil.getCommandArgMethodInfo(methodName,window.menuItemId,window.formId);
		if(!mi)
		{
			if(options.authorityArg["query"] == false)
			{
				if(window.parent.userInfos && window.parent.userInfos.userGroups && window.parent.userInfos.userGroups.length>0){
					Warning.show({text:"您没有权限进去该画面"});
				}else{
					Warning.show({text:"您所在的用户组没有权限"});
				}
			}
			else
			{
				FormLoadHelper.openMenuItem(options);
			}
			return;
		}
		var commandArg = CommandResolver.getSendCmd(options.fm, options.groupAlias, mi);
		
		if(options.groupAlias && options.dataField)
		{
			i = options.dataField.indexOf(".");
			var _fieldName = StringUtil.convertToEachFirstUpperCase(options.dataField.substring(i+1));
		}
		else
		{
			_fieldName = options.editorName;
		}
		
		var openMainFormArg = {
			remoteClass:"gongqi.erp.gotmodel.form.remote.OpenMainFormArg",
			menuItemId:options.menuItemId,
			paramString:options.paramString,
			mainFormWhereValues:options.mainTableWhereValues
		}
		
		var command = CommandHelper.createFormInstance(options.fm.formName, "doMainForm", "OpenMainFormArg").
			appendArg(options.groupAlias).
			appendArg(_fieldName).
			appendArg(commandArg, "CommandArg").
			appendArg(openMainFormArg, "OpenMainFormArg");
		var remoteArg = {command:command,resultFunction:this.rpc_result_mainFormArg.bind(this,options)};
		ServiceHelper.addTokenWithCommand(remoteArg);
	}

	static rpc_result_mainFormArg(options,data)
	{
		var omfa = data.result;

		if(!omfa || !omfa.menuItemId)
		{
			Warning.show({text:"检测到二次开发未能传回有效的MenuItemId",title:"进入主表失败了哦"});
			return;
		}

		options.menuItemId = omfa.menuItemId;
		options.paramString = omfa.paramString;
		options.mainTableWhereValues = omfa.mainFormWhereValues;
		options.enterMainForm = true;
		
		var authorityObject = AuthorityUtil.getAuthorityMenuItem(options.menuItemId);
		if(authorityObject["query"] == false)
		{
			Warning.show({text:"您所在的用户组没有权限"});
		}
		else
		{
			FormLoadHelper.openMenuItem(options);
		}
	}

	static getMainTableWhereValues2(
			args)
	{
		let entityId = args.entityId;let innerId = args.innerId;
		let componentItemName = args.componentItemName;
		let value = args.value;let result = args.result; let record = args.record;
		var mtr = null;var mainTableValues = [];
		//var formItemDataSource;
		//var form = GOT.getForm(entityId);
		/*if(form)
		{
			var formItem = GOT.getFormItem(form,innerId);
			formItemDataSource = GOTUtil.getProperty(formItem, "DataSource");
			if(formItemDataSource.hasOwnProperty("innerid"))
			{
				var ds = GOT.getFormDataSource(form,formItemDataSource.innerid);
				var dsTablePro = GOTUtil.getProperty(ds,"Table");
				var table = GOT.getTable(dsTablePro.refentityid);
				var mainTable = result["mainTable"];
				var mainTableId = mainTable.id;
				var trs = [];
				var tableRelations = table.TableRelations.Relations;
				for(let i = 0;i<tableRelations.length;i++)
				{
					let tr = trs[i];
					let hasFixed = false;
					let tableRelationItems = tr.Items;
					for(let k = 0;k<tableRelationItems.length;k++)
					{
						let tableRelationItem = tableRelationItems[k];
						if(tableRelatinItem.type == "Fixed")
						{
							hasFixed = true;
							break;
						}
					}
					if(hasFixed)
						continue;
					mtr = tr;
					break;
				}
			}
			else
			{
				mtr = null;
			}
		}
		else
		{
			mtr = null;
		}*/
		
		
		
		
		if(mtr)
		{
			var kv;
			var rfList = mtr.TableRelationItems;//.(@type=="RelatedFixed");
			for(let i = 0;i<rfList.length;i++)
			{
				let rf = rfList[i];
				kv = {remoteClass:"gongqi.erp.gotmodel.form.remote.StringKeyValue"};
				if(rf.type=="Normal")
				{
					kv.key = GOTUtil.getPropertyValue(rf, "RelatedField") ||
							 GOTUtil.getPropertyValue(rf,"ParentField");
					if(!record)
						kv.value = "";
					else
						kv.value = record[formDataSource.Value+"."+StringUtil.convertToFirstLowerCase(
														GOTUtil.getPropertyValue(rf, "Field"))];
				}
				else if(rf.type=="RelatedFixed")
				{
					kv.key = GOTUtil.getPropertyValue(rf, "RelatedField") ||
							 GOTUtil.getPropertyValue(rf,"ParentField");
					kv.value = GOTUtil.getPropertyValue(rf, "Value");
				}
				mainTableValues.push(kv);
			}
			return mainTableValues;
		}
		else
		{
		
			var dataTypeRelation = result["dataTypeRelation"];
			if(!dataTypeRelation)
				return [];
			
			let fieldPro = dataTypeRelation.Properties.Field;
			if(!fieldPro)return [];
			if(!fieldPro.V)return [];

			var kv = {remoteClass:"gongqi.erp.gotmodel.form.remote.StringKeyValue"};
			kv.key = fieldPro.V;
			kv.value = value;
			mainTableValues.push(kv);

			if(args.filterValue)
			{
				var filterFieldV = GOTUtil.getPropertyValue(dataTypeRelation,"FilterField");

				var kv2 = {remoteClass:"gongqi.erp.gotmodel.form.remote.StringKeyValue"};
				kv2.key = filterFieldV;
				kv2.value = args.filterValue;
				mainTableValues.push(kv2);
			}
			

			return mainTableValues;				
			var relationItems = dataTypeRelation.DataTypeRelationItems;
			var fieldPro;var fixedPro;
			for(let i = 0;i<relationItems.length;i++)
			{
				let relationItem = relationItems[i];
				fieldPro = GOTUtil.getProperty(relationItem,"Field")//relationItem.Properties.Property.(Name == "Field");
				if(relationItem.type == "Normal")
				{
					kv = {remoteClass:"gongqi.erp.gotmodel.form.remote.StringKeyValue"};
					kv.key = fieldPro.V;
					kv.value = value;
					mainTableValues.push(kv);
				}
				else
				{
					fixedPro = GOTUtil.getProperty(relationItem,"FixedValue");
					kv = {remoteClass:"gongqi.erp.gotmodel.form.remote.StringKeyValue"};
					kv.key = fieldPro.V;
					kv.value = fixedPro.V;
					mainTableValues.push(kv);
				}
			}
			return mainTableValues;
		}
	}
}



// WEBPACK FOOTER //
// ./src/utils/MainFormFactory.js